import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button"];
  static values = { name: String };

  checkMatch() {
    this.buttonTarget.disabled =
      this.inputTarget.value.trim() !== this.nameValue;
  }
}
